import { render, staticRenderFns } from "./flowtype-list.vue?vue&type=template&id=371fbafb&"
import script from "./flowtype-list.vue?vue&type=script&lang=js&"
export * from "./flowtype-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "flowtype-list.vue"
export default component.exports